<template>
  <div>
    <h1>404</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {}
  },
  methods: {
    back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/dashboard' }).catch(() => { })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
